import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TaxCodeResponse } from 'types/TaxcodeTypes';

export interface MiscProps {
  taxCodes: Array<TaxCodeResponse>;
}

const initialState: MiscProps = {
  taxCodes: [],
};

const miscSlice = createSlice({
  name: 'misc',
  initialState,

  reducers: {
    setTaxCodes: (state, action: PayloadAction<TaxCodeResponse[]>) => {
      state.taxCodes = action.payload;
    },

    resetState: () => ({ ...initialState }),
  },
});

export const { actions: miscActions, reducer } = miscSlice;

export default miscSlice.reducer;
